module.exports = __webpack_public_path__ + "img/fi-organic-breakfast.358173d2.jpg";